<tui-root>
<router-outlet />

</tui-root>